import * as React from "react";
import { UnhandledErrorsToastContainer } from "app/utils/UnhandledErrorsToastContainer";
import { GlobalStyle } from "app/styling/AppGlobalStyle";
import { ErrorBoundary } from "app/components/ErrorBoundary";

export const RootComponents = () => (
  <React.Fragment>
    <GlobalStyle />
  </React.Fragment>
);



// WEBPACK FOOTER //
// ./app/RootComponents.tsx